import { render, staticRenderFns } from "./uploadPicTextMore.vue?vue&type=template&id=0d02d99f&scoped=true"
import script from "./uploadPicTextMore.vue?vue&type=script&lang=js"
export * from "./uploadPicTextMore.vue?vue&type=script&lang=js"
import style0 from "./uploadPicTextMore.vue?vue&type=style&index=0&id=0d02d99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d02d99f",
  null
  
)

export default component.exports